import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-base"></i>
              </div>
              <span className="font-logo text-xl text-background-50">菠萝蜜网</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              菠萝蜜网专注提供高清电影、电视剧及综艺资讯，内容丰富、更新及时，助你轻松找到心仪的影视作品。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">影视分类</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li><Link to="/category/movie" className="hover:text-accent-400 cursor-pointer">电影大全</Link></li>
              <li><Link to="/category/tv" className="hover:text-accent-400 cursor-pointer">电视剧全集</Link></li>
              <li><Link to="/category/variety" className="hover:text-accent-400 cursor-pointer">综艺精选</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">关于我们</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li><Link to="/about" className="hover:text-accent-400 cursor-pointer">网站介绍</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 cursor-pointer">全站搜索</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">联系方式</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2"><i className="ri-mail-line"></i>contact@boluomiwang.com</li>
              <li className="flex items-center gap-2"><i className="ri-customer-service-2-line"></i>在线客服 9:00-22:00</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 菠萝蜜网 保留所有权利</p>
          <p>本站内容仅供参考与界面演示，不提供真实影视播放服务</p>
        </div>
      </div>
    </footer>
  );
}